<template>
  <div
    ref="navRef"
    class="hc-nav"
  >
    <h1 class="hc-nav__title">{{ props.title }}</h1>
    <div class="hc-nav__chips">
      <UiChip
        v-for="chip in props.chips"
        :key="chip.name"
        class="hc-nav__chips-item"
        :label="chip.name"
        :size="EUiChipSize.S"
        :selected="false"
        v-on:click="scrollTo(chip.link)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { EUiChipSize, UiChip } from '@experience/core-chips-ui';

  export interface IChip {
    name: string;
    link: string;
  }

  interface IProps {
    title: string;
    chips: IChip[];
  }
  const props = defineProps<IProps>();

  const navRef = ref<HTMLElement | null>(null);
  const root = computed(() => navRef.value?.getRootNode?.() as ShadowRoot | Document);

  const scrollTo = (id: string) => {
    const el = root.value.getElementById(id);
    const yOffset = -50;

    if (el) {
      const y = el.getBoundingClientRect().top + yOffset;

      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };
</script>

<style scoped lang="scss">
  .hc-nav {
    text-align: center;

    @include adaptivity.tablet {
      text-align: start;
    }
  }

  .hc-nav__title {
    margin-top: 56px;
    margin-bottom: 0;

    @include typography.base-1100-1050-extra;

    @include adaptivity.tablet {
      margin-top: 24px;

      @include typography.base-800-750-extra;
    }
  }

  .hc-nav__chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
    align-items: center;
    margin-top: 24px;

    @include adaptivity.tablet {
      justify-content: start;
    }

    @include adaptivity.mobile {
      margin-top: 16px;
    }
  }
</style>
